import React from 'react';
import { Modal } from 'antd';
import { css } from '@emotion/css';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  TelegramShareButton,
  LinkedinShareButton,
  RedditShareButton,
  EmailShareButton,
  FacebookIcon,
  XIcon,
  WhatsappIcon,
  TelegramIcon,
  LinkedinIcon,
  RedditIcon,
  EmailIcon,
} from 'react-share';
import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { useState } from 'react';

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  title: string;
}

export const ShareModal: React.FC<ShareModalProps> = ({ isOpen, onClose, url, title }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const iconSize = 40;
  const modalContainerStyle = css`
    display: flex;
    flex-direction: column;
    gap: 20px;
  `;

  const modalHeaderStyle = css`
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 0;
  `;

  const copyLinkContainerStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    margin-bottom: 10px;
    background-color: #f9f9f9;
  `;

  const copyLinkTextStyle = css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 1;
    padding-right: 10px;
  `;

  const copyButtonStyle = css`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    color: ${copied ? '#52c41a' : '#1d72b9'};
    font-weight: 500;
    padding: 5px 10px;
    border-radius: 4px;
    background-color: #f0f0f0;
    border: none;
    transition: all 0.2s;
    
    &:hover {
      background-color: #e0e0e0;
    }
  `;

  const shareButtonsContainerStyle = css`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  `;

  return (
    <Modal 
      title="Share this interactive summary"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
    >
      <div className={modalContainerStyle}>
        
        
        <div className={copyLinkContainerStyle}>
          <div className={copyLinkTextStyle} title={url}>
            {url}
          </div>
          <button className={copyButtonStyle} onClick={handleCopyLink}>
            {copied ? <CheckOutlined /> : <CopyOutlined />}
            {copied ? 'Copied!' : 'Copy link'}
          </button>
        </div>

        <div className={shareButtonsContainerStyle}>
          <FacebookShareButton url={url} quote={title}>
            <FacebookIcon size={iconSize} round />
          </FacebookShareButton>

          <TwitterShareButton url={url} title={title}>
            <XIcon size={iconSize} round />
          </TwitterShareButton>

          <WhatsappShareButton url={url} title={title}>
            <WhatsappIcon size={iconSize} round />
          </WhatsappShareButton>

          <TelegramShareButton url={url} title={title}>
            <TelegramIcon size={iconSize} round />
          </TelegramShareButton>

          <LinkedinShareButton url={url} title={title}>
            <LinkedinIcon size={iconSize} round />
          </LinkedinShareButton>

          <RedditShareButton url={url} title={title}>
            <RedditIcon size={iconSize} round />
          </RedditShareButton>

          <EmailShareButton url={url} subject={title} body={`Check out this summary: ${url}`}>
            <EmailIcon size={iconSize} round />
          </EmailShareButton>
        </div>
      </div>
    </Modal>
  );
};
